import { render, staticRenderFns } from "./pWareItem.vue?vue&type=template&id=3a71919a&scoped=true"
import script from "./pWareItem.vue?vue&type=script&lang=js"
export * from "./pWareItem.vue?vue&type=script&lang=js"
import style0 from "./pWareItem.vue?vue&type=style&index=0&id=3a71919a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71919a",
  null
  
)

export default component.exports